import { http } from "@/utils/http";
export const getBannerList = (params) => {
  // 获取视频banner
  return http({ url: "/1/banners", method: "GET", params: params });
};
